// src/components/admin/TenantForm.js
import React, { useState } from 'react';

const TenantForm = ({ user, initialData = {}, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    ...initialData
  });

  const isEditMode = !!initialData.id;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData, isEditMode);
  };

  return (
    <form onSubmit={handleSubmit} className="admin-form">
      <div className="admin-form-group">
        <label>Tenant Name *</label>
        <input 
          type="text" 
          name="name" 
          value={formData.name} 
          onChange={handleChange} 
          required 
          placeholder="Enter tenant name (e.g., Acme Bank)"
        />
      </div>

      <div className="admin-form-actions">
        <button type="submit" className="admin-button primary">
          {isEditMode ? 'Update Tenant' : 'Create Tenant'}
        </button>
        <button type="button" onClick={onCancel} className="admin-button secondary">
          Cancel
        </button>
      </div>

      {isEditMode && (
        <div className="admin-form-info">
          <p><strong>Note:</strong> Changing tenant name will affect all associated resources.</p>
        </div>
      )}
    </form>
  );
};

export default TenantForm; 